var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"host",staticClass:"shadow-html-host"})
}
var staticRenderFns = []

export { render, staticRenderFns }